import Api from './ApiRequest';

export default {
    getAll: (params) => Api.get('/usr/departments',params),
    getById: (id) => Api.get('/usr/department/' + id, null),
    save: (entity) => Api.post('/usr/department', entity),
    update: (id, entity) => Api.put('/usr/department/' + id, entity),
    setDefault: (id) => Api.put('/usr/department/' + id + '/setdefault'),
    delete: (id) => Api.delete('/usr/department/' + id),
    search: (searchText, params = {}) => Api.get('/usr/departments/search', {...params, q: searchText}),
    getMembers: (id, params) => Api.get('/usr/department/'+ id + '/members',params),
    getStats: () => Api.get('/usr/departments/stats', null),
};